import {signal} from '@angular/core';
import {TileInfo} from '@models/tile-info';
import {ProjectBaseModel} from '@project/project-base.model';
import {keyValueTableObject} from '@shared/components/key-value-table/key-value-table.component';

export abstract class ProjectBaseAbstract {
  project = signal<ProjectBaseModel | null>(null);
  datasetTiles: TileInfo[] = [];
  resourceTiles: TileInfo[] = [];
  metaTableData!: keyValueTableObject;

  protected setProjectData(project: ProjectBaseModel, datasetTiles: TileInfo[], resourceTiles: TileInfo[]) {
    this.project.set(project);
    this.datasetTiles = datasetTiles;
    this.resourceTiles = resourceTiles;
    this.buildMetadataTable();
  }

  protected abstract buildMetadataTable(): void;
}
